export default __webpack_public_path__ + "static/media/Icon-List-Add-Disabled.c2593b09.svg";